import React from 'react';
import { Card } from '../../../ui/molecules/Card';
import { SectionHeader } from '../../../ui/molecules/SectionHeader';
import type { ServiceItem } from '../resume.types';

type ServicesSectionProps = {
  services: ServiceItem[];
};

export function ServicesSection({ services }: ServicesSectionProps) {
  return (
    <section
      id="services"
      className="px-4 py-16 bg-stone-100/50 dark:bg-stone-800/50"
      aria-labelledby="services-heading"
    >
      <div className="mx-auto max-w-4xl">
        <SectionHeader
          id="services-heading"
          title="What I do"
          subtitle="Mobile development and consultancy"
        />
        <div className="grid gap-6 sm:grid-cols-2">
          {services.map((service, index) => (
            <Card key={service.id} animationDelay={index * 60}>
              <h3 className="font-display text-lg font-semibold text-stone-800 dark:text-stone-100">
                {service.title}
              </h3>
              <p className="mt-2 text-stone-600 leading-relaxed dark:text-stone-400">
                {service.description}
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
